module.exports = __webpack_public_path__ + "img/zuku.45c64822.png";